import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ThemeList,
  ThemeName,
  ValidThemes,
} from '../../../core/theme/model/theme.model';
import { ThemeService } from '../../../core/theme/theme.service';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-theme-switcher',
  imports: [TitleCasePipe],
  templateUrl: './theme-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './theme-switcher.component.scss',
})
export class ThemeSwitcherComponent {
  currentTheme$: Observable<ThemeName>;
  ThemeList = ThemeList;
  ValidThemes: string[] = [];

  constructor(private themeService: ThemeService) {
    this.currentTheme$ = this.themeService.currentTheme$;
    const themes: string[] = ValidThemes;
    const defaultTheme = themes.shift() || 'default';

    themes.sort();
    themes.unshift(defaultTheme);

    this.ValidThemes = themes;
  }

  switchTheme(event: Event) {
    const target = event.target as HTMLSelectElement;
    const newTheme: ThemeName = target.value as ThemeName;

    this.themeService.setTheme(newTheme);
  }
}
